export function applyPhoneFormat (val: string) {
    return val.replace(/(\+380)(\d{2})(\d{3})(\d{4})/, '$1\xa0($2)\xa0$3\u2011$4');
}
